export const experimentsPrivateRoutesConstants = {
  root: {
    path: "/r/app/experiments",
    href: (projectId: string) => `/r/app/experiments?project=${projectId}`
  },
  single_experiment: {
    path: "/r/app/experiments/:experimentId",
    href: (experimentId: string, projectId: string) =>
      `/r/app/experiments/${experimentId}?project=${projectId}`
  },

  create_experiment: {
    path: "/r/app/experiments/create",
    href: (projectId: string, ideaId?: string) =>
      `/r/app/experiments/create?project=${projectId}${
        ideaId ? `&story=${ideaId}` : ""
      }`
  },

  edit_experiment: {
    path: "/r/app/experiments/:experimentId/edit",
    href: (experimentId: string, projectId: string) =>
      `/r/app/experiments/${experimentId}/edit?project=${projectId}`
  }
} as const;
